import { render, staticRenderFns } from "./PageRenderer.vue?vue&type=template&id=600d89bc"
import script from "./PageRenderer.vue?vue&type=script&lang=js"
export * from "./PageRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports